export const sex = [
  { codigo: 'male', etiqueta: 'Masculino' },
  { codigo: 'female', etiqueta: 'Femenino' },
];
